// Simple icon mapping for each technology type
export const technologyIcons = {
    SolarBattery: 'fa-battery-full',
    MonitoringSystem: 'fa-desktop',
    PowerDiverter: 'fa-random',
    EVCharger: 'fa-bolt',
    SolarInverter: 'fa-plug',
    SolarPanel: 'fa-solar-panel',
    BlackoutProtection: 'fa-shield-alt',
    SmartDevice: 'fa-microchip',
    Optimiser: 'fa-sliders-h',
    HeatPump: 'fa-temperature-low',
    WaterCylinder: 'fa-water',
};

// Friendly display names
export const technologyLabels = {
    SolarBattery: 'Solar Battery',
    MonitoringSystem: 'Monitoring System',
    PowerDiverter: 'Power Diverter',
    EVCharger: 'EV Charger',
    SolarInverter: 'Solar Inverter',
    SolarPanel: 'Solar Panel',
    BlackoutProtection: 'Blackout Protection',
    SmartDevice: 'Smart Device',
    Optimiser: 'Optimiser',
    HeatPump: 'Heat Pump',
    WaterCylinder: 'Water Cylinder',
};
